import "../../styles/layout.scss";
import logo from "../../assets/logo-mobile.svg";
import { ReactComponent as avatar } from "../../assets/avatar.svg";
import { Avatar, Box, Button, IconButton, Tooltip } from "@mui/material";
import { $isAuth } from "../../store/isAuthStore"
import { useUnit } from "effector-react"
import { Login } from "@mui/icons-material";
import { isMobile } from "react-device-detect";
import Icon, { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

export const Header = ({ collapsed = false, onToggle }) => {
    const isAuth = useUnit($isAuth);

    const handleClick = () => {
        window.location.href = "/userProfile";
    };

    const goToAuthorization = () => {
        window.location.href = `/authorization?returnUrl=${window.location.pathname}`;
    }

    return (

        <div className="layout__header">
            {!isMobile &&
                <Button
                    className={!collapsed ? "layout__header__menuBtnFold" : "layout__header__menuBtnUnFold"}
                    onClick={onToggle}>
                    {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                </Button>}
            {isMobile && <div>
                <img className="layout__header__logo" src={logo} alt="Логотип" />
            </div>}
            <Box className={!isMobile ? "layout__header__profile" : "layout__header__profile--mobile"}>
                <Tooltip title="Account settings">
                    <Icon className="layout__header__avatar" onClick={handleClick} component={avatar} />
                </Tooltip>
            </Box>
        </div>
    )
}